export function mascaraCep(valor = "") {
  valor = valor.replace(/\D/g, "");
  valor = valor.slice(0, 8);

  if (valor.length > 5) {
    valor = valor.replace(/^(\d{5})(\d)/, "$1-$2");
  }

  return valor;
}

export function mascaraCnpj(valor = "") {
  valor = valor.replace(/\D/g, "");
  valor = valor.slice(0, 14);

  if (valor.length <= 2) {
    return valor;
  }

  if (valor.length <= 5) {
    return valor.replace(/^(\d{2})(\d+)/, "$1.$2");
  }

  if (valor.length <= 8) {
    return valor.replace(
      /^(\d{2})(\d{3})(\d+)/,
      "$1.$2.$3"
    );
  }

  if (valor.length <= 12) {
    return valor.replace(
      /^(\d{2})(\d{3})(\d{3})(\d+)/,
      "$1.$2.$3/$4"
    );
  }

  return valor.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/,
    "$1.$2.$3/$4-$5"
  );
}

export function mascaraCpf(valor = "") {
  valor = valor.replace(/\D/g, "");
  valor = valor.slice(0, 11);

  if (valor.length <= 3) {
    return valor;
  }

  if (valor.length <= 6) {
    return valor.replace(
      /^(\d{3})(\d+)/,
      "$1.$2"
    );
  }

  if (valor.length <= 9) {
    return valor.replace(
      /^(\d{3})(\d{3})(\d+)/,
      "$1.$2.$3"
    );
  }

  return valor.replace(
    /^(\d{3})(\d{3})(\d{3})(\d+)/,
    "$1.$2.$3-$4"
  );
}

export function mascaraTelefone(valor = "") {
  valor = valor.replace(/\D/g, "");
  valor = valor.slice(0, 11);

  if (valor.length === 0) {
    return "";
  }

  if (valor.length <= 2) {
    return `(${valor}`;
  }

  if (valor.length <= 6) {
    return valor.replace(
      /^(\d{2})(\d+)/,
      "($1) $2"
    );
  }

  // Telefone fixo
  if (valor.length <= 10) {
    return valor.replace(
      /^(\d{2})(\d{4})(\d+)/,
      "($1) $2-$3"
    );
  }

  // Celular
  return valor.replace(
    /^(\d{2})(\d{5})(\d+)/,
    "($1) $2-$3"
  );
}

export function mascaraRg(valor = "") {
  // RG varia bastante entre estados.
  // Aqui apenas impedimos caracteres especiais indesejados
  // e limitamos o tamanho.
  return valor
    .replace(/[^a-zA-Z0-9]/g, "")
    .slice(0, 14);
}
